"use client";

import { Splash } from "@/components/Splash/Splash";
import { Icon } from "@cloudspire/shared/components/Icon/Icon";
import { Button } from "@cloudspire/shared/components/ui/button";
import { Center } from "@cloudspire/shared/components/ui/center";
import { parseDetailErrorV2 } from "@cloudspire/shared/helpers/api/parseDetailErrorV2";
import { useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";

/** @type {import("@cloudspire/shared/components/DataHandler/DataHandler").DataHandlerErrorComponent} */
export const SplashError = ({ error, mutate, status }) => {
  const intl = useIntl();

  const apiErrorDetail = useMemo(() => {
    return parseDetailErrorV2({ parsedJson: error });
  }, [error]);

  if (status === 401) {
    return (
      <Splash
        splashName="error"
        title={intl.formatMessage({ defaultMessage: "Autorisation requise" })}
        description={
          apiErrorDetail ??
          intl.formatMessage({
            defaultMessage:
              "Vous ne disposez pas des autorisations nécessaires.",
          })
        }
      />
    );
  }

  if (status === 422) {
    return (
      <Splash
        splashName="error"
        title={intl.formatMessage({ defaultMessage: "Requête invalide" })}
        description={
          apiErrorDetail ??
          intl.formatMessage({
            defaultMessage: "Les données spécifiées sont invalides",
          })
        }
      />
    );
  }

  return (
    <Splash
      splashName="error"
      title={intl.formatMessage({ defaultMessage: "Erreur" })}
      description={
        apiErrorDetail ??
        intl.formatMessage({
          defaultMessage: "Une erreur est survenue.",
        })
      }
    >
      <Center>
        <Button variant="outline" onClick={mutate}>
          <Icon icon="ms_refresh" />

          <FormattedMessage defaultMessage="Rafraîchir" />
        </Button>
      </Center>
    </Splash>
  );
};
